/* Pagina de produs.

   Galerie + lightbox, trepte de cantitate, variante, WhatsApp, contoarele din „ce observă clienții”,
   săgețile programului de 90 de zile și butoanele de comandă repetate prin pagină.

   - Nimic nu atârnă de funcții globale sau de id-uri unice: totul e legat de rădăcina secțiunii,
     [data-dl-product], deci merg mai multe instanțe.
   - Lightbox-ul și modalul etichetei sunt <dialog> (Escape și focus trap native).
   - Formularul e cel standard Shopify. Scriptul ăsta NU adaugă nimic în coș: ține la zi câmpurile
     formularului (varianta în [data-dl-variant-input], cantitatea în [data-dl-qty]) și starea butonului
     [data-dl-atc]; trimiterea o face theme.js (DL.bindAtcForms: /cart/add.js + sertarul de coș) sau,
     fără sertar, browserul (POST normal spre /cart/add).
   - CANTITATEA are o singură sursă: câmpul ascuns [data-dl-qty] din formularul de produs. Treptele
     din erou, cele din secțiunea „Oferte (produs)” și bara lipicioasă doar o scriu și o oglindesc
     (applyQty, mai jos); butoanele repetate și bara apasă același submit, deci trimit aceeași cantitate.
   - Totalurile treptelor se recalculează în JS cu exact aceeași aritmetică ca în Liquid
     (bundleTotals), ca schimbarea variantei să nu strice prețurile randate pe server.
   - Fiecare ascultător e strâns la shopify:section:unload (editorul de teme aruncă nodul vechi).

   Globala expusă: DLProduct (ajutoarele pure merg și în Node, fără window/document; în browser
   primește în plus bindOrderButtons/bindLabelDialog, expuse pentru teste). */
(function (root) {
  'use strict';

  /* ===== Ajutoare pure (testate în test/unit/bundles.test.mjs) ===== */

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  /* Totalurile unei trepte de pachet, în bani.
     total = preț × cantitate − floor(preț × cantitate × reducere / 100), exact ca Liquid-ul din
     main-product / product-offers; was = prețul barat (sau prețul întreg) × cantitate. */
  function bundleTotals(priceCents, compareCents, qty, discountPct, amountOffCents) {
    var price = Math.max(0, toInt(priceCents, 0));
    var quantity = Math.max(1, toInt(qty, 1));
    var discount = Math.min(100, Math.max(0, toInt(discountPct, 0)));
    var compare = Math.max(price, toInt(compareCents, 0));
    /* Reducerea (în bani) se rotunjește în JOS și se scade din total — altfel pagina ar arăta cu
       1 ban mai puțin decât plata (ex. 2 × 79,99 −10 % = 143,99, nu 143,98). */
    var full = price * quantity;
    var total = full - Math.floor((full * discount) / 100);
    /* Reducere fixă în bani, scăzută după procent, niciodată sub 0. */
    total = Math.max(0, total - Math.max(0, toInt(amountOffCents, 0)));
    return { total: total, was: compare * quantity, perUnit: Math.round(total / quantity) };
  }

  /* Următoarea cantitate permisă: urcă/coboară pe treptele existente, iar peste ultima treaptă
     pasul devine liber (± 1). Nu coboară niciodată sub 1. */
  function nextAllowedQty(current, dir, tiers) {
    var list = (tiers || [])
      .map(function (t) { return toInt(t, 0); })
      .filter(function (t) { return t > 0; })
      .sort(function (a, b) { return a - b; });
    var cur = Math.max(1, toInt(current, 1));
    var up = toInt(dir, 1) > 0;
    if (!list.length) return up ? cur + 1 : Math.max(1, cur - 1);
    if (up) {
      for (var i = 0; i < list.length; i++) if (list[i] > cur) return list[i];
      return cur + 1;
    }
    if (cur > list[list.length - 1]) return cur - 1;
    for (var j = list.length - 1; j >= 0; j--) if (list[j] < cur) return list[j];
    return 1;
  }

  /* Varianta potrivită combinației alese de client.
     `values` e lista valorilor selectate, pe indexul opțiunii (o poziție poate lipsi: la stilul
     „butoane", o opțiune fără buton bifat lasă o gaură în listă, iar Array#every sare peste găuri).
     Reguli:
       • dintre variantele care se potrivesc, o preferăm pe una DISPONIBILĂ — varianta veche lua
         orbește `filter(...)[0]`, deci o combinație parțială putea ateriza pe una epuizată;
       • dacă toate potrivirile sunt epuizate, întoarcem totuși prima, ca pagina să se repicteze
         și butonul să spună „Stoc epuizat";
       • dacă nu se potrivește NICIUNA (combinație inexistentă în Shopify), întoarcem
         `{ variant: null, available: false }` — apelantul marchează epuizat în loc să nu facă nimic
         (comportamentul vechi: applyVariant(undefined) ieșea tăcut și pagina rămânea pe varianta
         precedentă, adică selectorul părea stricat). */
  function pickVariant(variants, values) {
    var list = variants || [];
    var vals = values || [];
    var matches = list.filter(function (v) {
      return vals.every(function (val, i) { return !val || (v.options || [])[i] === val; });
    });
    for (var i = 0; i < matches.length; i++) {
      if (matches[i].available !== false) return { variant: matches[i], available: true };
    }
    return { variant: matches[0] || null, available: false };
  }

  /* Treapta care se aplică unei cantități: cea exactă, altfel cea mai mare de SUB ea (o reducere
     „de la 2 bucăți” se aplică și la 4); sub prima treaptă nu se aplică niciuna. Întoarce indexul din
     `tierQtys` sau -1. */
  function tierIndexForQty(tierQtys, qty) {
    var want = Math.max(1, toInt(qty, 1));
    var best = -1;
    var bestQty = 0;
    (tierQtys || []).forEach(function (raw, i) {
      var q = toInt(raw, 0);
      if (q > 0 && q <= want && q > bestQty) { best = i; bestQty = q; }
    });
    return best;
  }

  /* Totalurile pentru `qty` bucăți când e aleasă treapta `tier` = { qty, pct, amountOff } (valorile
     EFECTIVE de pe rând, `data-qb-pct` / `data-qb-amount-off`: Liquid le pune pe 0 cât reducerile nu
     sunt confirmate în setări). Pagina nu promite ce plata n-ar da: procentul se aplică doar de la
     cantitatea treptei în sus, suma fixă doar pe cantitatea exactă; fără treaptă = preț întreg. */
  function tierTotals(priceCents, compareCents, qty, tier) {
    var quantity = Math.max(1, toInt(qty, 1));
    var tierQty = tier ? Math.max(1, toInt(tier.qty, 1)) : 0;
    var pct = tier && quantity >= tierQty ? toInt(tier.pct, 0) : 0;
    var amountOff = tier && quantity === tierQty ? toInt(tier.amountOff, 0) : 0;
    /* Lotul 13c, D1: „N bucăți gratuite” (`tier.free`, din `data-qb-free`) — doar pe cantitatea EXACTĂ a treptei și doar
       dacă rămâne măcar o bucată plătită; ia locul procentului și al sumei fixe: total = (cantitate − gratuite) × preț,
       exact ca Liquid-ul din main-product / product-offers. Fără `free` (0) nu se schimbă nimic. */
    var free = tier && quantity === tierQty ? Math.max(0, toInt(tier.free, 0)) : 0;
    if (free > 0 && free < quantity) { pct = 0; amountOff = free * Math.max(0, toInt(priceCents, 0)); }
    return bundleTotals(priceCents, compareCents, quantity, pct, amountOff);
  }

  /* ===== Estimarea de livrare („Primește coletul între X și Y”) — nu promite date pe care nimeni nu le-a spus =====
     Totul se socotește în ORA MAGAZINULUI (Europe/Sofia), nu a vizitatorului, pe zile de calendar (fără ore, deci
     schimbarea orei de vară nu mută nimic). Zilele lucrătoare: luni–vineri, fără sărbătorile legale bulgare (fixe +
     Vinerea Mare → Lunea Paștelui, după Paștele ortodox al anului). Ziua expedierii e azi dacă e zi lucrătoare și
     comanda e înainte de ora-limită, altfel următoarea zi lucrătoare; de acolo se numără `minDays` (începutul) și
     `maxDays` (sfârșitul) zile lucrătoare. Fără zile sau fără oră-limită nu se calculează nimic (null). */
  var DAY_MS = 86400000;
  var SOFIA = 'Europe/Sofia';
  var WEEKDAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  /* Data și ora de la Sofia ale unui moment: { y, m (1–12), d, hh, mm, weekday (0 = duminică) }. */
  function sofiaParts(date) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: SOFIA, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short' })
      .formatToParts(date).forEach(function (p) { parts[p.type] = p.value; });
    return { y: +parts.year, m: +parts.month, d: +parts.day, hh: +parts.hour % 24, mm: +parts.minute, weekday: WEEKDAY_INDEX[parts.weekday] };
  }
  function partsOf(utcMs) { var d = new Date(utcMs); return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate(), weekday: d.getUTCDay() }; }

  /* Paștele ortodox (Meeus, calendarul iulian), adus în calendarul gregorian (+13 zile între 1900 și 2099): [an, lună, zi]. */
  function orthodoxEaster(year) {
    var a = year % 4, b = year % 7, c = year % 19;
    var d = (19 * c + 15) % 30;
    var e = (2 * a + 4 * b - d + 34) % 7;
    var month = Math.floor((d + e + 114) / 31);
    var day = ((d + e + 114) % 31) + 1;
    var g = new Date(Date.UTC(year, month - 1, day + 13));
    return [g.getUTCFullYear(), g.getUTCMonth() + 1, g.getUTCDate()];
  }
  /* Sărbătorile legale din Bulgaria, ca „LL-ZZ”: fixe + Vinerea Mare, Sâmbăta Mare, Paștele și Lunea Paștelui + zilele
     libere-substitut: Codul muncii, art. 154 (2) — o sărbătoare (alta decât zilele de Paște) care cade sâmbăta sau duminica
     face nelucrătoare prima zi lucrătoare de după ea: lunea următoare, sau mai departe dacă și aceea e sărbătoare ori e deja
     substitutul altei zile (2027: 1 mai sâmbătă → luni 3 e Lunea Paștelui → marți 4; 25 + 26 dec. → luni 27 ȘI marți 28). */
  function bgHolidays(year) {
    var fixed = ['01-01', '03-03', '05-01', '05-06', '05-24', '09-06', '09-22', '12-24', '12-25', '12-26'];
    var days = fixed.slice();
    var easter = orthodoxEaster(year);
    var base = Date.UTC(easter[0], easter[1] - 1, easter[2]);
    for (var off = -2; off <= 1; off++) { var p = partsOf(base + off * DAY_MS); var md0 = pad2(p.m) + '-' + pad2(p.d); if (days.indexOf(md0) < 0) days.push(md0); }
    for (var i = 0; i < fixed.length; i++) {
      var md = fixed[i].split('-');
      var t = Date.UTC(year, +md[0] - 1, +md[1]);
      var wd = new Date(t).getUTCDay();
      if (wd !== 0 && wd !== 6) continue;
      t += (wd === 6 ? 2 : 1) * DAY_MS;
      var q = partsOf(t);
      while (q.weekday === 0 || q.weekday === 6 || days.indexOf(pad2(q.m) + '-' + pad2(q.d)) >= 0) { t += DAY_MS; q = partsOf(t); }
      days.push(pad2(q.m) + '-' + pad2(q.d));
    }
    return days;
  }
  function isWorkingDay(utcMs) {
    var p = partsOf(utcMs);
    if (p.weekday === 0 || p.weekday === 6) return false;
    return bgHolidays(p.y).indexOf(pad2(p.m) + '-' + pad2(p.d)) < 0;
  }

  /* Fereastra de livrare: { start, end } ca { y, m, d, weekday }, sau null fără zile / fără oră-limită validă — „H:MM” sau
     „HH:MM” între 00:00–23:59; „25:00” sau „17:60” tastate în editor = fără oră-limită, cutia rămâne ascunsă.
     min > max: max se aduce la min. */
  function deliveryWindow(now, minDays, maxDays, cutoff) {
    var min = Math.max(0, toInt(minDays, 0));
    var max = Math.max(0, toInt(maxDays, 0));
    var cut = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(String(cutoff || '').trim());
    if (!max || !cut) return null;
    if (min > max) max = min;
    var p = sofiaParts(now);
    var afterCutoff = p.hh * 60 + p.mm >= (+cut[1]) * 60 + (+cut[2]);
    var t = Date.UTC(p.y, p.m - 1, p.d);
    if (afterCutoff || !isWorkingDay(t)) { do { t += DAY_MS; } while (!isWorkingDay(t)); }
    var counted = 0, start = null, end = null;
    for (var guard = 0; end === null && guard < 120; guard++) {
      t += DAY_MS;
      if (!isWorkingDay(t)) continue;
      counted++;
      if (counted === min) start = t;
      if (counted === max) end = t;
    }
    if (end === null) return null;
    return { start: partsOf(start === null ? end : start), end: partsOf(end) };
  }

  /* „понеделник, 12 октомври” (cu etichetele lunilor), „понеделник 12.10” (fără), „12 октомври” (fără eticheta zilei). */
  function formatDeliveryDate(p, dayLabels, monthLabels) {
    var day = String((dayLabels || [])[(p.weekday + 6) % 7] || '').trim();
    var month = String((monthLabels || [])[p.m - 1] || '').trim();
    if (month) return (day ? day + ', ' : '') + p.d + ' ' + month;
    return (day ? day + ' ' : '') + pad2(p.d) + '.' + pad2(p.m);
  }

  /* Leagă o cutie [data-dl-delivery]: calculează fereastra, scrie mesajul (din data-dl-delivery-template) cu datele
     escapate în locul substituenților și scoate `hidden`. Întoarce false (și nu atinge nimic) fără zile sau oră-limită. */
  function bindDelivery(box, now) {
    var split = function (s) { return String(s || '').split(',').map(function (x) { return x.trim(); }); };
    var win = deliveryWindow(now, box.getAttribute('data-min-days'), box.getAttribute('data-max-days'), box.getAttribute('data-cutoff'));
    var text = box.querySelector('[data-dl-delivery-text]');
    if (!win || !text) return false;
    var days = split(box.getAttribute('data-days'));
    var months = split(box.getAttribute('data-months'));
    var esc = function (s) { return String(s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); };
    var template = text.getAttribute('data-dl-delivery-template') || '';
    text.innerHTML = template.split('[start_date]').join(esc(formatDeliveryDate(win.start, days, months))).split('[end_date]').join(esc(formatDeliveryDate(win.end, days, months)));
    box.removeAttribute('hidden');
    return true;
  }

  root.DLProduct = root.DLProduct || {};
  root.DLProduct.bundleTotals = bundleTotals;
  root.DLProduct.nextAllowedQty = nextAllowedQty;
  root.DLProduct.pickVariant = pickVariant;
  root.DLProduct.tierIndexForQty = tierIndexForQty;
  root.DLProduct.tierTotals = tierTotals;
  root.DLProduct.sofiaParts = sofiaParts;
  root.DLProduct.orthodoxEaster = orthodoxEaster;
  root.DLProduct.bgHolidays = bgHolidays;
  root.DLProduct.deliveryWindow = deliveryWindow;
  root.DLProduct.formatDeliveryDate = formatDeliveryDate;
  root.DLProduct.bindDelivery = bindDelivery;

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* ===== Partea de DOM ===== */

  var DL = (window.DL = window.DL || {});
  /* Niciun text în română nu mai stă aici: șirurile vin din theme/locales/*.json, injectate în
     `window.DLSettings.t` de layout/theme.liquid (`atcBundle` = products.add_count_to_cart,
     `wa` = products.whatsapp_message). Locurile lor („{{ count }}", „{{ quantity }}", …) sunt
     completate de fill(). t() întoarce '' dacă șirul lipsește, iar apelanții tratează cazul. */
  function t(key) {
    var s = window.DLSettings && window.DLSettings.t && window.DLSettings.t[key];
    return typeof s === 'string' ? s : '';
  }

  function fill(template, values) {
    return Object.keys(values).reduce(function (s, k) {
      return s.replace(new RegExp('{{\\s*' + k + '\\s*}}', 'g'), values[k]);
    }, template);
  }

  /* Banii vin din DL.money (theme.js, formatul magazinului). Rezerva, fără theme.js, e formatul euro — nicio
     monedă românească scrisă în cod. */
  function money(cents) {
    if (DL && typeof DL.money === 'function') return DL.money(cents);
    return '€' + (Number(cents) / 100).toFixed(2).replace('.', ',');
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ===== Butoanele de comandă repetate prin pagină =====

     [data-dl-order-btn] (snippets/order-button.liquid) nu are formular propriu: apasă submit-ul real
     al paginii, [data-dl-atc], deci trimite exact varianta și cantitatea din formularul de produs —
     același drum ca butonul din erou (theme.js: /cart/add.js + sertar, sau POST normal).
       · submit dezactivat fiindcă varianta e epuizată → nu se trimite nimic; ducem omul la buton,
         unde scrie „Stoc epuizat” (un click care nu face nimic ar părea un buton stricat);
       · submit dezactivat fiindcă o adăugare e în curs (`aria-busy`, pus de theme.js) → ignorăm;
       · pagină fără formular (blocul „Adaugă în coș” lipsește) → derulăm la secțiunea de produs.
     Legarea e document-wide (nu scoped la [data-dl-product]): butoanele trăiesc în alte secțiuni. */
  /* Butoanele repetate urmează cantitatea aleasă, ca butonul din erou (paintAtc): la `dl:bundle-changed` eticheta devine
     „Добави N броя в количката” (atcBundle) pentru N > 1 și revine la a lor pentru 1; aria-label („Etichetă: produs”) la fel,
     ca numele accesibil să conțină textul vizibil. Fără traducere rămâne eticheta randată de Liquid. */
  /* Pagina-advertorial (23.10.2026): când secțiunea de produs e în modul „Ofertă” (main-product, layout = offer — snippets/
     product-offer.liquid, [data-dl-offer-mode]), butoanele din ARTICOL (în afara ofertei) duc la ofertă, ca „VEZI SOLUȚIA” de pe
     naturvia.ro (derulare lină la blocul de ofertă), și nu adaugă direct în coș: omul alege treapta acolo. Își păstrează eticheta. */
  function offerOutside(btn) {
    var offer = document.querySelector('[data-dl-offer-mode]');
    return offer && !offer.contains(btn) ? offer : null;
  }
  function paintOrderButtons(qty) {
    var label = t('atcBundle');
    var btns = document.querySelectorAll('[data-dl-order-btn]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (!b.dataset.bound) continue;
      if (offerOutside(b)) continue;
      var own = b.dataset.dlLabel || b.textContent;
      var next = qty > 1 && label ? fill(label, { count: qty }) : own;
      if (b.textContent !== next) b.textContent = next;
      if (b.dataset.dlAria) b.setAttribute('aria-label', b.dataset.dlAria.replace(own, next));
    }
  }
  var orderButtonsListening = false;
  function bindOrderButtons(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    if (!orderButtonsListening) {
      orderButtonsListening = true;
      document.addEventListener('dl:bundle-changed', function (e) { paintOrderButtons(toInt(e && e.detail && e.detail.qty, 1)); });
    }
    var btns = scope.querySelectorAll('[data-dl-order-btn]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (!btn || btn.dataset.bound) continue;
      btn.dataset.bound = '1';
      if (!btn.dataset.dlLabel) btn.dataset.dlLabel = btn.textContent;
      if (!btn.dataset.dlAria && btn.getAttribute('aria-label')) btn.dataset.dlAria = btn.getAttribute('aria-label');
      (function (btn) {
        function onClick() {
          var offer = offerOutside(btn);
          if (offer) {
            if (typeof offer.scrollIntoView === 'function') offer.scrollIntoView({ block: 'start', behavior: reducedMotion() ? 'auto' : 'smooth' });
            return;
          }
          var atc = document.querySelector('[data-dl-atc]');
          if (atc && !atc.disabled) { atc.click(); return; }
          if (atc && atc.getAttribute('aria-busy') === 'true') return;
          var target = atc || document.querySelector('[data-dl-product]');
          if (target && typeof target.scrollIntoView === 'function') {
            target.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
          }
        }
        btn.addEventListener('click', onClick);
        function cleanup() { btn.removeEventListener('click', onClick); delete btn.dataset.bound; }
        if (DL && typeof DL.onDestroy === 'function') DL.onDestroy(btn, cleanup);
      })(btn);
    }
  }

  /* ===== Modalul etichetei =====

     [data-dl-label-open] e butonul de sub galerie (main-product.liquid, secțiunea Produs) — cel
     mai des scoped chiar în secțiunea `section` primită de bindSection. Ce deschide diferă:
       · [data-dl-label-modal] — dialogul cu IMAGINEA etichetei, tot în `section`, dacă
         `label_image` e setată;
       · altfel, primul [data-dl-label-dialog] DIN DOCUMENT — secțiunea nouă „Eticheta produsului"
         (product-label.liquid), care NU e copil al [data-dl-product]: trăiește separat în pagină,
         de-asta căutarea ei e mereu document.querySelector, nu $(...) scoped la `section`.
     La init, dacă butonul e randat ascuns (fără `label_image`, vezi main-product.liquid) și există
     un [data-dl-label-dialog] pe pagină, îl arătăm — altfel n-are ce să deschidă, rămâne ascuns.
     Butoanele [data-dl-label-close] și clicul pe fundal (dialogul însuși, în afara panoului) închid
     oricare dintre cele două dialoguri — de-asta bucla de mai jos e document-wide, nu scoped:
     dialogul nou nu e văzut deloc de un `$(...)` legat de `section`.
     Extrasă ca funcție numită (nu inline în bindSection) și expusă pe DLProduct DOAR pentru teste
     (test/unit/product-label.test.mjs), la fel ca bindOrderButtons mai sus — nimic din temă n-o cheamă
     altundeva, iar expunerea nu schimbă comportamentul. */
  function bindLabelDialog(section) {
    var openBtn = section && section.querySelector('[data-dl-label-open]');
    if (openBtn && !openBtn.dataset.bound) {
      openBtn.dataset.bound = '1';
      if (openBtn.hidden && document.querySelector('[data-dl-label-dialog]')) openBtn.hidden = false;
      var onOpen = function (e) {
        e.preventDefault();
        var target = (section && section.querySelector('[data-dl-label-modal]')) || document.querySelector('[data-dl-label-dialog]');
        if (!target) return;
        if (typeof target.showModal === 'function' && !target.open) target.showModal();
        else target.setAttribute('open', '');
      };
      openBtn.addEventListener('click', onOpen);
      if (DL && typeof DL.onDestroy === 'function') {
        DL.onDestroy(openBtn, function () { openBtn.removeEventListener('click', onOpen); delete openBtn.dataset.bound; });
      }
    }
    Array.prototype.slice.call(document.querySelectorAll('[data-dl-label-close]')).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var onClose = function () {
        var dialog = typeof btn.closest === 'function' ? btn.closest('dialog') : null;
        if (!dialog) return;
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      btn.addEventListener('click', onClose);
      if (DL && typeof DL.onDestroy === 'function') {
        DL.onDestroy(btn, function () { btn.removeEventListener('click', onClose); delete btn.dataset.bound; });
      }
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-dl-label-modal], [data-dl-label-dialog]')).forEach(function (dialog) {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = '1';
      var onBackdrop = function (e) {
        if (e.target !== dialog) return;
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.addEventListener('click', onBackdrop);
      if (DL && typeof DL.onDestroy === 'function') {
        DL.onDestroy(dialog, function () { dialog.removeEventListener('click', onBackdrop); delete dialog.dataset.bound; });
      }
    });
  }

  /* Expuse pe DLProduct DOAR pentru teste (test/unit/order-flow.test.mjs / product-label.test.mjs le
     rulează pe un DOM-stub, ca să verifice comportamentul, nu forma sursei). Nimic din temă nu le
     cheamă de-aici, iar expunerea nu schimbă comportamentul. */
  root.DLProduct.bindOrderButtons = bindOrderButtons;
  root.DLProduct.bindLabelDialog = bindLabelDialog;

  function bindSection(section) {
    if (section.dataset.bound) return;
    section.dataset.bound = '1';

    var teardown = [];
    function on(el, evt, handler, opts) {
      if (!el) return;
      el.addEventListener(evt, handler, opts);
      teardown.push(function () { el.removeEventListener(evt, handler, opts); });
    }
    var $ = function (sel) { return section.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(section.querySelectorAll(sel)); };

    var qtyInput = $('[data-dl-qty]');
    var atcBtn = $('[data-dl-atc]');
    var variantInput = $('[data-dl-variant-input]');
    var dynamicEl = $('[data-dl-dynamic-checkout]');

    /* ---------- Galerie ---------- */
    var mainImg = $('[data-dl-gallery-main]');
    var thumbs = $$('[data-dl-thumb]');
    var lightbox = $('[data-dl-lightbox]');
    var lightboxImg = $('[data-dl-lightbox-img]');
    var lightboxCounter = $('[data-dl-lightbox-counter]');
    var index = 0;

    function paintThumbs() {
      thumbs.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('border-primary', active);
        btn.classList.toggle('border-2', active);
        btn.classList.toggle('border-secondary-subtle', !active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (thumbs[index] && thumbs[index].scrollIntoView) {
        thumbs[index].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    }

    function goTo(i) {
      if (!thumbs.length) return;
      index = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var src = thumbs[index].dataset.src;
      var srcset = thumbs[index].dataset.srcset;
      if (mainImg && src) {
        // Miniatura poartă ȘI setul de rezoluții al imaginii ei (data-srcset, aceleași lățimi ca
        // în <img>-ul din main-product.liquid). Le punem pe amândouă: dacă am seta doar `src`,
        // browserul ar rămâne cu vechiul `srcset` (imaginea greșită) — iar dacă l-am șterge, ca
        // înainte, ecranele retina ar primi de-acum o singură rezoluție în loc de 600/900/1200.
        if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
        mainImg.src = src;
      }
      paintThumbs();
      if (lightbox && lightbox.open) paintLightbox();
    }

    thumbs.forEach(function (btn, i) { on(btn, 'click', function () { goTo(i); }); });
    on($('[data-dl-gallery-prev]'), 'click', function (e) { e.preventDefault(); goTo(index - 1); });
    on($('[data-dl-gallery-next]'), 'click', function (e) { e.preventDefault(); goTo(index + 1); });

    var wrap = $('[data-dl-gallery-wrap]');
    if (wrap && thumbs.length > 1) {
      on(wrap, 'click', function () { goTo(index + 1); });
      var startX = 0, startY = 0, startedAt = 0;
      on(wrap, 'touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY; startedAt = Date.now();
      }, { passive: true });
      on(wrap, 'touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Date.now() - startedAt < 600 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) goTo(dx < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }

    /* Tastatură: săgeți stânga/dreapta când focusul e în galerie (nu global, ca în sursa de referință). */
    var galleryCol = $('.product-gallery-col') || wrap;
    on(galleryCol, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    function paintLightbox() {
      if (!lightboxImg) return;
      var src = thumbs[index] ? thumbs[index].dataset.full : (mainImg && mainImg.currentSrc) || (mainImg && mainImg.src);
      if (src) lightboxImg.src = src;
      if (lightboxCounter) lightboxCounter.textContent = index + 1;
    }

    function openLightbox() {
      if (!lightbox) return;
      paintLightbox();
      if (typeof lightbox.showModal === 'function' && !lightbox.open) lightbox.showModal();
      else lightbox.setAttribute('open', '');
      document.body.classList.add('dl-lightbox-open');
    }

    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function' && lightbox.open) lightbox.close();
      else lightbox.removeAttribute('open');
      document.body.classList.remove('dl-lightbox-open');
    }

    on($('[data-dl-gallery-zoom]'), 'click', function (e) { e.preventDefault(); e.stopPropagation(); openLightbox(); });
    on($('[data-dl-lightbox-close]'), 'click', closeLightbox);
    on($('[data-dl-lightbox-prev]'), 'click', function () { goTo(index - 1); });
    on($('[data-dl-lightbox-next]'), 'click', function () { goTo(index + 1); });
    if (lightbox) {
      on(lightbox, 'click', function (e) { if (e.target === lightbox) closeLightbox(); });
      on(lightbox, 'close', function () { document.body.classList.remove('dl-lightbox-open'); });
      on(lightbox, 'keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });
    }

    /* ---------- Modalul etichetei: bindLabelDialog (mai sus) își face curățenia prin DL.onDestroy pe elementele ei,
       deci nu mai are nevoie de `teardown`/`on()` aici. ---------- */
    bindLabelDialog(section);

    /* ---------- Cantitatea și treptele ----------

       O SINGURĂ sursă pentru cantitatea aleasă: câmpul ascuns [data-dl-qty] din formularul de produs.
       Treptele pot sta în două locuri — blocul „Pachete de cantitate” din secțiunea asta și secțiunea
       „Oferte (produs)” de mai jos din pagină (un [data-dl-bundles] în afara oricărui [data-dl-product]).
       Orice schimbare trece prin applyQty(): scrie cantitatea în câmp, repictează FIECARE grup pe
       treapta potrivită cantității, reface eticheta butonului și emite o dată `dl:bundle-changed`
       (bara lipicioasă ascultă). Deci o treaptă aleasă într-un loc o mută și pe cealaltă. */
    var atcLabel = (atcBtn && (atcBtn.dataset.dlAtcLabel || atcBtn.textContent.trim())) || '';
    /* Varianta curentă e epuizată? Starea stă într-un singur loc: marcajul `data-dl-sold-out` de pe
       submit, pus de server din `variant.available` și rescris aici la schimbarea variantei.
       NICIODATĂ din `disabled`: acela e și starea de „se adaugă…” pusă de theme.js, iar un browser
       îl poate readuce la reîncărcare / Înapoi — un produs în stoc ar apărea „Stoc epuizat”, cu
       toate drumurile de comandă blocate. paintAtc() (rulat și la pornire) pune `disabled` și
       eticheta după marcaj, deci un buton în stoc ajuns dezactivat e reactivat. */
    function isSoldOut() {
      return !!atcBtn && atcBtn.dataset.dlSoldOut === 'true';
    }
    function setSoldOut(value) {
      if (atcBtn) atcBtn.dataset.dlSoldOut = value ? 'true' : 'false';
    }

    /* Prețul variantei curente, în bani — randat de Liquid pe rădăcina secțiunii și rescris de
       applyVariant() la schimbarea variantei. `data-dl-no-compare` (pe secțiune: show_deal_plate
       oprit; pe un grup de trepte: „Arată prețul tăiat” oprit) = se ignoră prețul vechi. */
    function currentPrices(group) {
      var noCompare = section.hasAttribute('data-dl-no-compare') || !!(group && group.hasAttribute('data-dl-no-compare'));
      return { price: toInt(section.dataset.price, 0), compare: noCompare ? 0 : toInt(section.dataset.compare, 0) };
    }

    function currentQty() {
      return qtyInput ? Math.max(1, toInt(qtyInput.value, 1)) : 1;
    }

    /* Grupurile de trepte legate de formularul ăsta: cele din secțiune, plus — dacă formularul e
       cel principal al paginii (primul [data-dl-qty] din document) — cele din afara secțiunilor de
       produs. Citite la fiecare folosire: editorul de teme poate re-randa „Oferte” oricând. */
    function tierGroups() {
      var groups = $$('[data-dl-bundles]');
      if (qtyInput && document.querySelector('[data-dl-product] [data-dl-qty]') === qtyInput) {
        Array.prototype.slice.call(document.querySelectorAll('[data-dl-bundles]')).forEach(function (g) {
          if (!g.closest('[data-dl-product]')) groups.push(g);
        });
      }
      return groups;
    }
    function groupRows(group) {
      return Array.prototype.slice.call(group.querySelectorAll('.dl-qb-row'));
    }
    /* Treapta unui rând, cu valorile EFECTIVE puse de Liquid (procent 0 cât reducerile nu sunt confirmate). */
    function tierOf(row) {
      /* D1: treapta cu bucăți gratuite (`data-qb-free`, pus de Liquid doar cu reducerile confirmate) — fără procent și fără sumă fixă */
      var free = toInt(row.dataset.qbFree, 0);
      if (free > 0) return { qty: Math.max(1, toInt(row.dataset.qbQty, 1)), pct: 0, amountOff: 0, free: free };
      return { qty: Math.max(1, toInt(row.dataset.qbQty, 1)), pct: toInt(row.dataset.qbPct, 0), amountOff: toInt(row.dataset.qbAmountOff, 0) };
    }

    function paintRow(row, qty, totals, unitSingular, unitPlural) {
      var totalEl = row.querySelector('.dl-qb-row-total');
      var wasEl = row.querySelector('.dl-qb-row-was');
      var perUnitEl = row.querySelector('.dl-qb-row-perunit');
      var perUnitText = row.querySelector('[data-qb-perunit-text]');
      var savedEl = row.querySelector('[data-qb-saved-text]');
      var qtyTextEl = row.querySelector('[data-qb-qty-text]');
      if (qtyTextEl) qtyTextEl.textContent = qty + ' ' + (qty > 1 ? unitPlural : unitSingular);
      if (totalEl) totalEl.textContent = money(totals.total);
      /* Aceeași gardă ca în Liquid și ca în detaliul evenimentului: fără economie, nu arătăm
         preț tăiat (altfel, după o schimbare de variantă, ar apărea tăiat chiar totalul). */
      if (wasEl) { wasEl.textContent = money(totals.was); wasEl.hidden = totals.was <= totals.total; }
      /* eticheta ascunsă vizual a prețului vechi al treptei urmează prețul vechi */
      var wasLabelEl = row.querySelector('[data-qb-was-label]');
      if (wasLabelEl) wasLabelEl.hidden = totals.was <= totals.total;
      if (perUnitEl) perUnitEl.textContent = money(totals.perUnit) + (unitSingular ? ' / ' + unitSingular : '');
      if (perUnitText) perUnitText.textContent = money(totals.perUnit) + (unitSingular ? ' / ' + unitSingular : '');
      /* prețul pe zi (Oferte, 28.10.2026): bucata / zilele puse de Liquid pe element, rotunjit la ban */
      var perDayEl = row.querySelector('[data-qb-perday-text]');
      if (perDayEl) { var days = toInt(perDayEl.dataset.qbDays, 0); if (days > 0) perDayEl.textContent = money(Math.round(totals.perUnit / days)) + ' / ' + (perDayEl.dataset.qbDayLabel || ''); }
      if (savedEl) {
        savedEl.textContent = money(Math.max(0, totals.was - totals.total));
        var savingsEl = savedEl.closest ? savedEl.closest('.dl-qb-row-savings') : null;
        if (savingsEl) savingsEl.hidden = totals.was <= totals.total;
      }
      row.dataset.qbTotal = totals.total;
      row.dataset.qbWas = totals.was;
      row.dataset.qbPerunit = totals.perUnit;
    }

    /* Butonul de adăugare: dezactivat + „Stoc epuizat” pe o variantă epuizată, altfel eticheta
       potrivită cantității. Cât theme.js ține butonul ocupat cu o adăugare (`aria-busy`), nu-l
       atingem: la final el emite `dl:atc-idle` pe formular și repictăm atunci (mai jos). */
    function paintAtc() {
      var soldOut = isSoldOut();
      if (dynamicEl) dynamicEl.hidden = soldOut;
      if (!atcBtn || atcBtn.getAttribute('aria-busy') === 'true') return;
      atcBtn.disabled = soldOut;
      if (soldOut) {
        if (atcBtn.dataset.dlAtcSoldOut) atcBtn.textContent = atcBtn.dataset.dlAtcSoldOut;
        return;
      }
      if (!atcLabel) return;
      /* Fără traducerea `atcBundle` (DLSettings incomplet) rămâne eticheta randată de Liquid —
         mai bine decât un buton gol. */
      var qty = currentQty();
      var bundleLabel = t('atcBundle');
      atcBtn.textContent = qty > 1 && bundleLabel ? fill(bundleLabel, { count: qty }) : atcLabel;
    }
    if (atcBtn && atcBtn.form) on(atcBtn.form, 'dl:atc-idle', paintAtc);

    /* Singurul loc care schimbă cantitatea. `sourceRow` = treapta apăsată (dacă schimbarea vine
       dintr-un click pe o treaptă); altfel fiecare grup își alege singur treapta potrivită. */
    function applyQty(wantedQty, sourceRow) {
      var max = qtyInput ? toInt(qtyInput.max, 99) : 99;
      var qty = Math.max(1, Math.min(toInt(wantedQty, 1), max));
      var lead = null;       // rândul ale cărui totaluri pleacă în eveniment: cel apăsat, altfel primul grup
      var totals = null;
      tierGroups().forEach(function (group) {
        var rows = groupRows(group);
        if (!rows.length) return;
        var datasetTotals = function (r) { return { total: toInt(r.dataset.qbTotal, 0), was: toInt(r.dataset.qbWas, 0), perUnit: toInt(r.dataset.qbPerunit, 0) }; };
        /* Treapta ALEASĂ e cea apăsată sau cea cu exact cantitatea cerută; o cantitate care nu se potrivește cu nicio treaptă
           (5 din stepperul barei) nu alege niciuna. Prețul ei se calculează după treapta cea mai mare de sub ea (`pricing`). */
        var exact = sourceRow && group.contains(sourceRow)
          ? sourceRow
          : rows.filter(function (r) { return toInt(r.dataset.qbQty, 0) === qty; })[0] || null;
        var pricing = rows[tierIndexForQty(rows.map(function (r) { return r.dataset.qbQty; }), qty)] || null;
        var p = currentPrices(group);
        var unitSingular = group.dataset.unitSingular || '';
        var unitPlural = group.dataset.unitPlural || unitSingular;
        rows.forEach(function (r) {
          var on = r === exact;
          r.classList.toggle('is-active', on);
          r.setAttribute('aria-checked', on ? 'true' : 'false');
          var tier = tierOf(r);
          /* Fiecare treaptă își arată MEREU oferta ei (cantitatea treptei): rândul „Купи 3” nu devine „5 броя … €80,96” când
             stepperul barei trece de 3; totalul cantității cerute apare doar pe butoane și în bară. */
          var rowTotals = p.price ? tierTotals(p.price, p.compare, tier.qty, tier) : datasetTotals(r);
          if (p.price) paintRow(r, tier.qty, rowTotals, unitSingular, unitPlural);
        });
        if (!totals && pricing) {
          lead = exact;
          totals = p.price ? tierTotals(p.price, p.compare, qty, tierOf(pricing)) : (exact ? datasetTotals(exact) : null);
        }
        if (sourceRow && group.contains(sourceRow)) lead = sourceRow;
      });
      if (!totals) {
        var base = currentPrices(null);
        totals = bundleTotals(base.price, base.compare, qty, 0, 0);
      }

      if (qtyInput && String(qtyInput.value) !== String(qty)) qtyInput.value = qty;
      /* Sub prețul mare (pe bucată) stă eticheta „цена за 1 брой” cât e aleasă mai mult de o bucată. */
      var notes = $$('[data-dl-price-note]');
      for (var ni = 0; ni < notes.length; ni++) notes[ni].hidden = qty <= 1;
      paintAtc();
      try {
        document.dispatchEvent(new CustomEvent('dl:bundle-changed', {
          detail: {
            qty: qty,
            total: totals.total,
            /* Contract cu bara sticky: fără preț barat trimitem null, oglinda gărzii
               din Liquid care randează <s class="dl-qb-row-was"> doar când was > total. */
            was: totals.was > totals.total ? totals.was : null,
            perUnit: totals.perUnit,
            title: lead ? lead.dataset.qbTitle || '' : '',
            row: lead,
            section: section
          }
        }));
      } catch (e) { /* CustomEvent lipsă (browsere vechi) — restul funcționează */ }
    }

    /* Click pe o treaptă, din ORICE grup legat de formularul ăsta. Delegat pe document: secțiunea
       „Oferte” poate fi re-randată de editorul de teme fără ca secțiunea de produs să fie re-legată. */
    on(document, 'click', function (e) {
      var row = e.target && e.target.closest ? e.target.closest('.dl-qb-row') : null;
      if (!row) return;
      var group = row.closest('[data-dl-bundles]');
      if (!group || tierGroups().indexOf(group) === -1) return;
      applyQty(tierOf(row).qty, row);
    });

    $$('[data-dl-qty-step]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        if (!qtyInput) return;
        var tiers = [];
        tierGroups().slice(0, 1).forEach(function (g) { groupRows(g).forEach(function (r) { tiers.push(tierOf(r).qty); }); });
        applyQty(nextAllowedQty(currentQty(), toInt(btn.dataset.dlQtyStep, 1), tiers));
      });
    });

    /* Cantitate scrisă din afară în câmp (stepperul barei lipicioase trimite „change”). */
    if (qtyInput) on(qtyInput, 'change', function () { applyQty(qtyInput.value); });

    /* ---------- Variante ---------- */
    var variantsEl = $('[data-dl-variants]');
    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
    }
    var picker = $('[data-dl-variant-picker]');

    function selectedOptions() {
      if (!picker) return [];
      var values = [];
      picker.querySelectorAll('select[data-dl-option-index]').forEach(function (sel) {
        values[toInt(sel.dataset.dlOptionIndex, 0)] = sel.value;
      });
      picker.querySelectorAll('.variant-btn[aria-checked="true"]').forEach(function (btn) {
        values[toInt(btn.dataset.dlOptionIndex, 0)] = btn.dataset.dlOptionValue;
      });
      return values;
    }

    function applyVariant(variant) {
      if (!variant) return;
      section.dataset.variantId = variant.id;
      section.dataset.price = variant.price;
      section.dataset.compare = variant.compare_at_price || 0;
      if (variantInput) {
        variantInput.value = variant.id;
        /* Butonul rapid Shopify (payment_button) află varianta nouă din evenimentul „change” al
           câmpului `id` — fără el ar trimite la plată varianta de la încărcarea paginii. */
        try { variantInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { /* browser fără Event() */ }
      }

      var nowEl = $('[data-dl-price-now]');
      var wasEl = $('[data-dl-price-was]');
      var saveEl = $('[data-dl-price-save]');
      var badge = $('[data-dl-discount-badge]');
      if (nowEl) nowEl.textContent = money(variant.price);
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      var off = hasCompare ? Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;
      if (wasEl) { wasEl.textContent = money(variant.compare_at_price || 0); wasEl.hidden = !hasCompare; }
      /* eticheta ascunsă vizual a prețului vechi (snippets/price.liquid) urmează prețul vechi */
      var wasLabel = $('[data-dl-price-was-label]');
      if (wasLabel) wasLabel.hidden = !hasCompare;
      if (saveEl) { saveEl.textContent = '-' + off + '%'; saveEl.hidden = !hasCompare; }
      if (badge) { badge.textContent = '-' + off + '%'; badge.hidden = !hasCompare; }

      /* Epuizat: butonul spune „Stoc epuizat” și e dezactivat, iar butonul rapid dispare; când
         varianta redevine disponibilă, paintAtc() (din applyQty) pune la loc eticheta potrivită. */
      setSoldOut(variant.available === false);
      paintStock(!isSoldOut());
      showVariantImage(variant);

      /* Prețurile treptelor și eticheta butonului, pentru aceeași cantitate, la prețul variantei noi. */
      applyQty(currentQty());

      /* URL-ul primește ?variant=<id> ca pe orice temă Shopify — DAR nu în editorul de teme:
         acolo previzualizarea rulează într-un iframe al cărui URL e urmărit de editor, iar o
         rescriere din temă îl face să reîncarce sau să piardă secțiunea selectată. Pe magazin
         (window.Shopify.designMode e undefined) comportamentul rămâne neschimbat. */
      var inEditor = !!(window.Shopify && window.Shopify.designMode);
      if (!inEditor && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Rândul de stoc se rescrie din atributele randate de Liquid (fără șiruri RO în JS). */
    var stockEl = $('[data-dl-stock]');
    function paintStock(available) {
      if (!stockEl) return;
      var textEl = stockEl.querySelector('[data-dl-stock-text]');
      if (textEl) {
        textEl.className = available ? 'text-success' : 'text-danger';
        textEl.textContent = (available ? stockEl.dataset.labelIn : stockEl.dataset.labelOut) || '';
        textEl.insertAdjacentHTML('afterbegin', '<i class="bi ' + (available ? 'bi-check-circle-fill' : 'bi-x-circle-fill') + ' me-1"></i>');
      }
      /* Textul „mai sunt N bucăți” e randat pentru varianta inițială: îl ascundem pe una epuizată. */
      var lowEl = stockEl.querySelector('[data-dl-lowstock]');
      if (lowEl) lowEl.hidden = !available;
    }

    /* Imaginea variantei, dacă are una: activăm miniatura corespunzătoare, altfel doar schimbăm
       imaginea mare (varianta poate avea o imagine care nu e în galerie). */
    function showVariantImage(variant) {
      var image = variant && variant.featured_image;
      if (!image) return;
      var src = image.src || image;
      if (typeof src !== 'string') return;
      var base = src.split('?')[0];
      for (var i = 0; i < thumbs.length; i++) {
        if (String(thumbs[i].dataset.src || '').split('?')[0] === base) { goTo(i); return; }
      }
      if (mainImg) { mainImg.src = src; mainImg.removeAttribute('srcset'); }
    }

    /* Combinație inexistentă în Shopify (ex. o mărime care n-a fost creată pentru culoarea aleasă):
       nu există variantă de aplicat, dar pagina NU are voie să rămână pe varianta precedentă ca și
       cum nimic nu s-ar fi întâmplat. O marcăm explicit epuizată. */
    function markSoldOut() {
      setSoldOut(true);
      paintAtc();
      paintStock(false);
    }

    function onOptionChange() {
      var values = selectedOptions();
      if (!values.length) return;
      var picked = pickVariant(variants, values);
      if (picked.variant) applyVariant(picked.variant);
      else markSoldOut();
    }

    if (picker) {
      picker.querySelectorAll('select[data-dl-option-index]').forEach(function (sel) { on(sel, 'change', onOptionChange); });
      picker.querySelectorAll('.variant-btn').forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          var group = btn.parentElement;
          group.querySelectorAll('.variant-btn').forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('btn-primary', active);
            b.classList.toggle('active', active);
            b.classList.toggle('btn-outline-secondary', !active);
            b.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          onOptionChange();
        });
      });
    }

    /* Prețul de pornire: din varianta selectată la randare (ca să avem de unde recalcula). */
    var initialVariant = variants.filter(function (v) { return String(v.id) === String(section.dataset.variantId); })[0];
    if (initialVariant) {
      section.dataset.price = initialVariant.price;
      section.dataset.compare = initialVariant.compare_at_price || 0;
    }

    /* ---------- WhatsApp ---------- */
    $$('[data-dl-whatsapp]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        var phone = (btn.dataset.waPhone || '').replace(/[^0-9]/g, '');
        if (!phone) return;
        e.preventDefault();
        var msg = fill(t('wa'), {
          quantity: qtyInput ? Math.max(1, toInt(qtyInput.value, 1)) : 1,
          product: btn.dataset.waName || document.title,
          url: btn.dataset.waUrl || window.location.href
        });
        window.open('https://wa.me/' + phone + (msg ? '?text=' + encodeURIComponent(msg) : ''), '_blank', 'noopener');
      });
    });

    /* ---------- „Ce observă clienții” — contoare + bare ---------- */
    var feelCards = $$('[data-feel-card]');
    /* Procentele și barele sunt randate pline de Liquid (contează pentru SEO și pentru vizitatorii
       fără JS). Le aducem la 0 abia în momentul animației — cardul e sub prima vizualizare, deci
       nimeni nu apucă să vadă saltul, iar randările statice (capturi, boți) rămân corecte. */
    function animateFeel(card) {
      if (card.dataset.animated) return;
      card.dataset.animated = '1';
      var instant = reducedMotion();
      card.querySelectorAll('[data-feel-num]').forEach(function (el) {
        var target = toInt(el.dataset.feelNum, 0);
        var valEl = el.querySelector('.dl-pdp-feel-pct-val');
        if (!valEl || !target) return;
        if (instant) { valEl.textContent = target; return; }
        valEl.textContent = '0';
        var start = null;
        var frame = 0;
        var step = function (now) {
          if (start === null) start = now;
          var progress = Math.min(1, (now - start) / 1400);
          valEl.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
          if (progress < 1) frame = requestAnimationFrame(step);
          else { frame = 0; valEl.textContent = target; }
        };
        frame = requestAnimationFrame(step);
        /* Bucla trebuie oprită la descărcarea secțiunii, altfel scrie într-un nod detașat. */
        teardown.push(function () { if (frame) cancelAnimationFrame(frame); });
      });
      card.querySelectorAll('[data-feel-bar]').forEach(function (bar, i) {
        var target = toInt(bar.dataset.feelBar, 0);
        if (instant) { bar.style.width = target + '%'; return; }
        bar.style.width = '0%';
        /* +30 ms peste decalajul de 90 ms/bară: lasă un cadru pentru ca tranziția pe width să pornească. */
        var timer = setTimeout(function () { bar.style.width = target + '%'; }, i * 90 + 30);
        teardown.push(function () { clearTimeout(timer); });
      });
    }
    if (feelCards.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { animateFeel(entry.target); io.unobserve(entry.target); }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -50px 0px' });
        feelCards.forEach(function (card) { io.observe(card); });
        teardown.push(function () { io.disconnect(); });
      }
      /* Plasă de siguranță (boți, browsere fără observer, carduri deja în viewport). */
      var feelTimer = setTimeout(function () { feelCards.forEach(animateFeel); }, 6000);
      teardown.push(function () { clearTimeout(feelTimer); });
    }

    /* ---------- Estimarea de livrare: datele se calculează aici (bindDelivery), cutia iese din `hidden` abia după ---------- */
    $$('[data-dl-delivery]').forEach(function (box) { bindDelivery(box, new Date()); });

    /* ---------- Programul de 90 de zile — săgeți de derulare ---------- */
    $$('[data-pp-program-scroll]').forEach(function (scroller) {
      var grid = scroller.querySelector('.pp-program-grid');
      var prev = scroller.querySelector('[data-pp-scroll-prev]');
      var next = scroller.querySelector('[data-pp-scroll-next]');
      if (!grid) return;
      var step = function () {
        var card = grid.querySelector('.pp-program-card');
        if (!card) return grid.clientWidth * 0.85;
        var styles = window.getComputedStyle(grid);
        return card.offsetWidth + (parseFloat(styles.columnGap || styles.gap || '12') || 12);
      };
      var update = function () {
        var max = grid.scrollWidth - grid.clientWidth - 1;
        if (prev) prev.toggleAttribute('disabled', grid.scrollLeft <= 1);
        if (next) next.toggleAttribute('disabled', grid.scrollLeft >= max);
      };
      on(prev, 'click', function (e) { e.preventDefault(); grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
      on(next, 'click', function (e) { e.preventDefault(); grid.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(grid, 'scroll', update, { passive: true });
      on(window, 'resize', update);
      update();
    });

    /* Starea inițială. Cu trepte: rândul marcat de Liquid (altfel primul) dă cantitatea — o treaptă
       care pornește de la 2 bucăți pune 2 în formular, exact ce vede omul selectat. Fără trepte:
       cantitatea revine la valoarea din markup (un browser poate „restaura” câmpul la o reîncărcare,
       iar pagina ar arăta 1 și ar trimite altceva). applyQty emite și `dl:bundle-changed`. */
    function syncQty(initial) {
      var groups = tierGroups();
      var first = null;
      for (var g = 0; g < groups.length && !first; g++) first = groups[g].querySelector('.dl-qb-row.is-active') || groups[g].querySelector('.dl-qb-row');
      if (initial && first) applyQty(tierOf(first).qty, first);
      else if (initial) applyQty(qtyInput ? qtyInput.getAttribute('value') : 1);
      else applyQty(currentQty());
    }
    syncQty(true);
    /* Re-randare din editorul de teme a unei secțiuni cu trepte: rândurile noi primesc starea curentă. */
    section._dlProductSync = function () { syncQty(false); };

    section._dlProductCleanup = function () {
      teardown.forEach(function (fn) { fn(); });
      teardown.length = 0;
      /* Dacă secțiunea dispare cu lightbox-ul deschis, <body> ar rămâne blocat pe overflow. */
      closeLightbox();
      section._dlProductCleanup = null;
      section._dlProductSync = null;
      delete section.dataset.bound;
    };
  }

  function initProduct(scope) {
    var node = scope || document;
    if (node.matches && node.matches('[data-dl-product]')) bindSection(node);
    if (node.querySelectorAll) node.querySelectorAll('[data-dl-product]').forEach(bindSection);
    /* O secțiune cu trepte (re)încărcată separat (editorul de teme): treptele ei iau cantitatea și
       prețurile curente de la secțiunea de produs deja legată. */
    if (node !== document && node.querySelector && node.querySelector('[data-dl-bundles]')) {
      document.querySelectorAll('[data-dl-product]').forEach(function (section) {
        if (typeof section._dlProductSync === 'function') section._dlProductSync();
      });
    }
  }

  function cleanup(node) {
    if (!node) return;
    if (node.matches && node.matches('[data-dl-product]') && typeof node._dlProductCleanup === 'function') node._dlProductCleanup();
    if (node.querySelectorAll) {
      node.querySelectorAll('[data-dl-product]').forEach(function (section) {
        if (typeof section._dlProductCleanup === 'function') section._dlProductCleanup();
      });
    }
  }

  /* Scriptul secțiunii poate fi inclus de mai multe ori pe pagină (două secțiuni main-product
     în editor): ascultătorul global se pune o singură dată. */
  if (!DL._dlProductUnloadBound) {
    DL._dlProductUnloadBound = true;
    document.addEventListener('shopify:section:unload', function (e) { cleanup(e.target); });
  }

  /* theme.js e încărcat tot cu defer, la finalul body-ului: DL.use există abia la DOMContentLoaded.
     Legăm direct pentru pagina curentă și ne înregistrăm ca plugin pentru re-randările din
     editorul de teme (shopify:section:load → DL.init). bindSection e idempotent. */
  document.addEventListener('DOMContentLoaded', function () {
    initProduct(document);
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(initProduct);
  });

  /* Butoanele de comandă repetate trăiesc în alte secțiuni decât [data-dl-product], de-asta legarea
     lor e un plugin DL.use PROPRIU, document-wide, nu un apel din bindSection. `readyState ===
     'complete'` prinde cazul rar în care scriptul ăsta e injectat DUPĂ ce pagina a pornit deja
     (editorul de teme). */
  function registerOrderButtons() {
    bindOrderButtons(document);
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(bindOrderButtons);
  }
  document.readyState === 'complete' ? registerOrderButtons() : document.addEventListener('DOMContentLoaded', registerOrderButtons);
})(typeof globalThis !== 'undefined' ? globalThis : this);
